<template>
  <div class="equipment-schedule">

    <div class="left-menu">
      <Menus class="inner-menu" :menu="menuItems" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-maintenance-64.png" @menuClicked="menuClicked" style="width:100%"/>
     
    </div>

    <div class="gantt-container" ref="gantt-container" :style="ganttContainerStyle">
      <div class="date-container">
        <div class="date-title">Show timeline</div>
        <DateTimePicker placeholder="from" :value.sync="startDate" />
        <DateTimePicker placeholder="to" :value.sync="endDate" />
        <div class="refresh-container">
          <button @click="showRefreshDropdown = !showRefreshDropdown">{{ refreshText }}</button>
          <div v-if="showRefreshDropdown" class="refresh-dropdown">
            <div>Refresh Every:</div>
            <button @click="refreshIntervalClicked($event, 10)">10 seconds</button>
            <button @click="refreshIntervalClicked($event, 30)">30 seconds</button>
            <button @click="refreshIntervalClicked($event, 300)">5 minutes</button>
            <button @click="refreshIntervalClicked($event, 600)">10 minutes</button>
            <button @click="refreshIntervalClicked($event, 1800)">30 minutes</button>
            <button @click="refreshIntervalClicked($event, 3600)">1 hour</button>
            <button class="refresh-now" @click="refreshIntervalClicked($event, null)">Refresh Now</button>
            <button v-if="refreshInterval" class="cancel-refresh" @click="refreshIntervalClicked(null, null)">Cancel Refresh</button>
          </div>
        </div>
        <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
      </div>
      <div class="gantt-with-legends">
        <GanttChartV2 :items="ganttItems" @taskDetailClosed="ganttTaskClosed" @taskClicked="ganttTaskClicked" @rowClicked="ganttRowClicked" :timeZoneWidth.sync="ganttMainWidth"/>
        <div class="gantt-legends">
          <div class="gantt-legends-items" v-for="(l, i) in legendsItems" :key="i">
            <div class="gantt-legends-color" :style="{ backgroundColor: l['ColorHexa'] }"></div>
            <div>{{ l['ColorDesc'] }}</div>
          </div>
        </div>
      </div>
    </div>

    <RightMenu class="right-menu" :overlay="true" :maxWidth="550" :minWidth="330" :defaultWidth="420" :showCloseButton="true" :showMenu.sync="showRightMenu" :width.sync="rightMenuWidth">
      <div class="ems-title" style=" width: 100%; display: flex;  justify-content: space-between; align-items: center; padding: 5px;" :style="{ 'background-color': '#b3c4ff'}">
      {{popupTitle}}
      </div>
      
      <div class="ems-trip-container">
          <div class="rowBox">
                <DateTimePicker :isDisabled="viewMode" placeholder="Start Time" :value.sync="starttime" :errorMessage.sync="starttimeError"
                  style="margin: 0 5px 0 0; width:50%;" />
                <DateTimePicker :isDisabled="viewMode" placeholder="End Time" :value.sync="endtime" :errorMessage.sync="endtimeError"
                  style="margin: 0 0 0 5px; width:50%;" />
          </div>
          <InputQuery placeholder="From Location" :items="destinationList" itemKey="Destination Code" descKey="fromLoc" :selectedObject.sync="fromLoc" 
          :isRequired="true" :errorMessage.sync="fromLocError"/>

          <InputQuery placeholder="To Location" :items="destinationList" itemKey="Destination Code" descKey="toLoc" :selectedObject.sync="toLoc" 
          :isRequired="true" :errorMessage.sync="toLocError"/>

          <InputQuery placeholder="Reason Type" :items="reasoningList" itemKey="Reason Type" descKey="reason" :selectedObject.sync="selectedReason" 
          :isRequired="true" :errorMessage.sync="reasonError"/>

          <InputQuery placeholder="Availability" :items="availabilityList" itemKey="Availability" descKey="availability" :selectedObject.sync="selectedAvailability" 
          :isRequired="true" :errorMessage.sync="availabilityError"/>

          <Input placeholder="Remarks" :inputValue.sync="remarks"/>  
          <Filters class="vehicle-filter" title="Vehicles Selected" :tableData="vehicleList" itemKey="Inventory #" itemDesc="vehicle" @confirmClicked="filterConfirm"
            :selectedObject.sync="selectedVehicle" noneSelectedText="" />
        
          <div class="ems-footer">
            <button style="margin:5px;" @click="saveClicked">Save</button>
            <button style="margin:5px;" @click="closeMenu">Cancel</button>
          </div>
          
      </div>
  </RightMenu>

  </div> 
</template>

<script>
/* eslint-disable */
export default {
  components: {
    //REMAINING WORK
    //SAS control //done
    //error message for vehicle 
    //display "no vehicle selected" as default //done
    //auto close task details
    //top left container shouldnt move with the left menu
  },
  data: function() {
    return {
      
      //UI items
      ganttItems : [],
      startDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00`),
      endDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:59`),
      popupTitle: '',

      ganttItems: [],
      legendsItems: [],
      menuItems: [
        { title: 'New Schedule', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png' },
        { title: 'Edit Schedule', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png' },
        { title: 'Delete Schedule', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png' },
      ],
      showRightMenu: false,
      showemsTrip: false, // screen showing all trips, right before clicking Port Booking / Depot Booking
      emsTitle: '',
      emsLoading: false,
      emsTrips: [],
      consignmentDetails: null,
      showRefreshDropdown: false,
      refreshTime: 0,
      refreshTimeStart: 0,
      refreshInterval: null,

      //EMS DATA
      availabilityList: [],
      reasoningList: [],
      selectedSchedule: [],
      destinationList:[],
      vehicleList:[],

      //data input
      selectedAvailability: null,
      selectedReason: null,
      selectedVehicle:[],
      selectedVehicleCode:[],
      remarks:'',
      starttime:null,
      endtime:null,
      fromLoc: null,
      toLoc: null,
      scheduleID:'',

      //input validation
      starttimeError:'',
      endtimeError:'',
      reasonError:'',
      availabilityError:'',
      fromLocError:'',
      toLocError:'',
      entryRequired: [],
			entrySuccess: [],
			entryMessages: [],
			entryError: [],
    }
  },
  props: {
  },
  computed: {
    refreshText: function() {
      if (!this.refreshInterval) { return 'Refresh' }
      else {
        let totalSeconds = this.refreshTime;
        let inMinute = Math.floor(totalSeconds / 60);

        if (totalSeconds >= 60) {
          return `Refresh in ${inMinute} minute${inMinute > 1 ? 's' : ''}`;
        } else {
          return `Refresh in ${this.refreshTime} seconds`;
        }
      }
    },
  },
  methods: { 
    ganttTaskClicked: async function(e){
      this.selectedSchedule = e;
      this.scheduleID = this.selectedSchedule['cbid'];
     //get vehicle id of the clicked one
     this.selectedVehicleCode.push(this.selectedSchedule['ccol1text']); 
      console.log("schedule clicked!", this.scheduleID);
      //console.log("schedule details: ",this.selectedSchedule);
    },
    ganttTaskClosed: function(){
      this.scheduleID = '';
      this.selectedSchedule = [];
    },
    filterConfirm: function(items) {
      this.selectedVehicle = items;
      this.selectedVehicleCode = this.selectedVehicle.map((a) => {return a['Inventory #']});
      console.log(this.selectedVehicleCode);
    },
    menuClicked: async function(menu) {
      switch (menu['title']) {
        case 'New Schedule':
          console.log(menu['title']);
          this.clearScheduleForm();
          this.showRightMenu = true;
          this.popupTitle = menu['title'];
          break;
        case 'Edit Schedule':
          if (this.selectedSchedule.length == 0) {
            this.$showAlert('error', 'No Schedule Selected', 'Please select Schedule to edit');
          } else {
            console.log(this.scheduleID);
            this.popupTitle = menu['title'];
            this.showRightMenu = true;
            await this.populateSchedule(this.scheduleID);
            //this.populateSchedule(this.selectedSchedule['cbid']);
          }
          break;
        case 'Delete Schedule':
          if (this.selectedSchedule.length == 0) {
            this.$showAlert('error', 'No Schedule Selected', 'Please select Schedule to delete');
          } else {
            let deleting = await this.$showAlert('warning', 'Delete Equipment Schedule', `Are you sure you want to delete Equipment Schedule of id: ${this.selectedSchedule['cbid']}?`, [
							{ text: 'Delete', textColor: 'white', color: 'red' },
							{ text: 'Cancel', textColor: 'black', color: 'lightgray' },
						]);
						if (deleting == 'Delete') {
              //parameters correct
							let result = await this.$apiCallV2('/EquipmentSchedule/SaveVehicleSchedule', {action: 'D',
								scheduleid: this.selectedSchedule['cbid'], lorrylist: this.selectedVehicleCode});
							  console.log(result);
							if (result[0]['Results'] == 0) { // Delete successful
								this.$showAlert('success', 'Equipment Schedule Deleted', `Successfully deleted equipment schedule ${this.selectedSchedule['cbid']}`);
								this.$nextTick(async () => await this.getGanttDetails());
							} else { // Delete error
								this.$showAlert('error', 'Equipment Schedule NOT Deleted', `There was an error deleting equipment schedule ${this.selectedSchedule['cbid']}`);
							}
						}
          }
          break;
      }
    },
    clearScheduleForm: function(){
      this.selectedAvailability = null;
      this.selectedReason = null;
      this.selectedVehicle = [];
      this.remarks = '';
      this.starttime = new Date();
      this.endtime = null;
      this.fromLoc = null;
      this.toLoc = null;
      this.scheduleID = '';
    },
    //not done
    populateSchedule: async function(scheduleID){
      this.loading = true;
			this.loadText = 'Getting Details';
      let details = (await this.$apiCallV2(`/EquipmentSchedule/GetVehicleSchedule?scheduleid=${scheduleID}`))[0];
      this.starttime = details['FromDateTime'] ? new Date(details['FromDateTime']) : null;
      this.endtime = details['ToDateTime'] ? new Date(details['ToDateTime']) : null;
      this.fromLoc = this.destinationList.getSelected(details['FromDest'], 'Destination Code');

      this.toLoc = this.destinationList.getSelected(details['ToDest'], 'Destination Code');
      // this.toLoc = this.populateObject(this.destinationList, 'Destination Code', details['ToDest']);
      this.selectedReason = this.reasoningList.getSelected(details['ReasonType'], 'Reason Type');
      this.selectedAvailability = this.availabilityList.getSelected(details['Availability'] == 'Y' ? 'Yes' : (details['Availability'] == 'N' ? 'No' : ''), 'Availability');
      this.remarks = details['Remarks'];
    
      // this.filterConfirm(details['Lorry_No']);
      this.selectedVehicle = this.vehicleList.filter(v => v['Inventory #'] == details['Lorry_No']);
      console.log(this.selectedVehicle);

    //  this.selectedVehicle = this.populateObject(this.vehicleList, 'Vehicle', details['Lorry_No']);

    },
    refreshCountdown: function() {
      this.refreshTime--;
      if (this.refreshTime < 0) {
        this.refreshTime = this.refreshTimeStart;
      } else if (this.refreshTime == 0) {
        this.getGanttDetails();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    refreshIntervalClicked: function(e, seconds) {
      if (seconds) {
        this.refreshTime = seconds;
        if (e) { this.refreshTimeStart = seconds };
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(this.refreshCountdown, 1000);
      } else {
        if (e) {
          this.getGanttDetails();
        } else {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
          this.refreshTimeStart = 0;
        }
      }

      this.showRefreshDropdown = false;
    },
    getGanttDetails: async function() {
      this.$fullscreenLoading('Getting Details');

      this.ganttItems = [];
      this.ganttItems = await this.$apiCallV2(`/EquipmentSchedule/GanttViewTAS?starttime=${this.startDate.formatString('yyyy-MM-dd HH:mm')}&endtime=${this.endDate.formatString('yyyy-MM-dd HH:mm')}&viewtype=EMS_SCHEDULE`);
      
      console.log(this.ganttItems);
      this.lastRefresh = new Date().formatString('yyyy-MM-dd HH:mm');
      this.$fullscreenLoading();

      if (this.refreshTimeStart > 0) {
        this.refreshIntervalClicked(null, this.refreshTimeStart);
      }
    },
    saveClicked: async function(){
      let isNotValid = this.checkRequiredFields();
      
      if (this.selectedVehicle.length <= 0) {
        this.$showAlert('error', 'Compulsory field', 'Must select at least 1 vehicle');
        return;
      }

      if ( !isNotValid ) {
        let action = this.popupTitle[0];
        console.log(action);
        let dataToPost = {
              'reasontype': this.selectedReason ? this.selectedReason['Reason Type'] : '',
              'availability': this.selectedAvailability ? this.selectedAvailability['Availability'] : '',
              'fromdest': this.fromLoc ? this.fromLoc['Destination Code'] : '',
              'todest': this.toLoc ? this.toLoc['Destination Code'] : '',
              'lorrylist': this.selectedVehicleCode,
              'action': action,
              'fromdatetime': this.starttime ? this.$dateTime.getDateTime(this.starttime, 'yyyy-MM-dd') : '',
              'todatetime': this.endtime ? this.$dateTime.getDateTime(this.endtime, 'yyyy-MM-dd') : '',
              'remarks': this.remarks,
              'scheduleid': action == "N" ? "" : this.scheduleID,
              };
              console.log(dataToPost);
          this.$fullscreenLoading(`${dataToPost['Action'] == 'D' ? 'Delete' : 'Saving'} Schedule`);
          this.$fullscreenLoading('Saving Schedule');
          let result = await this.$apiCallV2('/EquipmentSchedule/SaveVehicleSchedule', dataToPost);
          this.$nextTick(async () => await this.getGanttDetails());
          console.log("result code: "+ result[0]['Results']);
          this.$fullscreenLoading();

          if (result[0]['Results'] == 0) { // Save successful
            if (action == 'N') {
              this.$showAlert('success','Successfully created equipment schedule. Reason: ',this.selectedReason['Reason Type']);
            } else {
              this.$showAlert('success','Successfully edited equipment schedule. Reason: ',this.selectedReason['Reason Type']);
            }
            this.showRightMenu = false;
          }else { // Save error
            if (action == 'N') {
              this.entryError.push(`There was an error creating schedule: ${result[0]['ErrMsg']}`);
            } else {
              this.entryError.push(`There was an error editing schedule: ${result[0]['ErrMsg']}`);
            }
          }
      }
    },
    closeMenu: function(){
      this.showRightMenu = false;
      this.clearScheduleForm();
    },
    checkRequiredFields: function () {
      this.clearEntryMessages();
      if (!this.starttime) {
				this.starttimeError = 'Start Time is required!';
				this.entryRequired.push({ key: 'starttime', value: 'Start Time is required!' });
			}
      if (!this.endtime) {
				this.endtimeError = 'End Time is required!';
				this.entryRequired.push({ key: 'endtime', value: 'End Time is required!' });
			}
      if (!this.selectedReason) {
				this.reasonError = 'Reason is required!';
				this.entryRequired.push({ key: 'reason', value: 'Reason is required!' });
			}
      if (!this.selectedAvailability) {
				this.availabilityError = 'Schedule Availability is required!';
				this.entryRequired.push({ key: 'availability', value: 'Schedule Availability is required!' });
			}
      if (!this.fromLoc) {
				this.fromLocError = 'Start Location is required!';
				this.entryRequired.push({ key: 'fromLoc', value: 'Start Location is required!' });
			}
      if (!this.toLoc) {
				this.toLocError = 'Destination is required!';
				this.entryRequired.push({ key: 'toLoc', value: 'Destination is required!' });
			}
      if (this.selectedVehicleCode.length == 0){
        this.vehicleError = 'Vehicle is required!';
        this.entryRequired.push({ key:'selectedVehicleCode', value: 'Vehicle is required!' });
      }
      
			return this.entryRequired.length > 0;
		},
    clearEntryMessages: function () {
			this.entryRequired = [];
			this.entrySuccess = [];
			this.entryMessages = [];
			this.entryError = [];

      this.starttimeError = '';
      this.endtimeError = '';
      this.reasonError = '';
      this.availabilityError = '';
      this.fromLocError = '';
      this.toLocError = '';
      this.vehicleError = '';
    	},
  },
  async mounted() {

    

    this.$bus.$on('pageSASControlAccess', (x) => {
			if (x.page == 'Equipment Schedule') {
				x.data.forEach(k => {
					console.log(k);
					//key in menu same as control value from api
					let selectedMenu = this.menu.find(m => m['key'] == k['Control']);		
					if (selectedMenu) {
						selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
					}
				})
			}
		})

    this.getGanttDetails();

    this.$fullscreenLoading('Getting Legends');
    this.legendsItems = await this.$apiCallV2('/EquipmentSchedule/GetLegends');

    this.$fullscreenLoading("Getting Destination List");
    this.destinationList = await this.$apiCallV2(`/EquipmentSchedule/GetListMaster?master=destination`);

    this.$fullscreenLoading("Getting Vehicle List");
    this.vehicleList = await this.$apiCallV2(`/EquipmentSchedule/GetListMaster?master=vehicle`);

    this.$fullscreenLoading("Getting schedule availability");
    this.availabilityList = await this.$apiCallV2(`/EquipmentSchedule/GetListMaster?master=EMS_SCHEDULE_AVAILABLE`);

    this.$fullscreenLoading("Getting scheduling reasons");
    this.reasoningList = await this.$apiCallV2(`/EquipmentSchedule/GetListMaster?master=EMS_SCHEDULE_REASON`);

    this.$fullscreenLoading();
  },
  watch: {
    showBookingPopup: function(val) {
      if (this.refreshInterval) {
        if (val) {
          clearInterval(this.refreshInterval);
        } else {
          this.refreshIntervalClicked(null, this.refreshTime);
        }
      }
    },
    // clear scheduleID when close gantt task azizi adding
    showRightMenu: function(val) {
      if(!val){
        this.clearEntryMessages();
      }
      
    }

  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.left-menu{
 height:100%;
  > .inner-menu{
    margin-top: 0px;
    height:30%;
    width: 100%;
  }
 
}
.equipment-schedule {
  width: 100%;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  > .gantt-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    position: relative;
    margin: 5px;

    > .date-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 5px 0;

      > * {
        margin-left: 5px;
      }

      > .date-title {
        height: 100%;
        position: relative;
        top: 3px;
      }

      > .refresh-container {
        position: relative;
        min-width: 200px;

        > button {
          width: 100%;
        }

        > .refresh-dropdown {
          position: absolute;
          top: 100%;
          background-color: white;
          width: 100%;
          z-index: 10;
          padding: 5px;
          border-width: 1px;
          border-style: solid;
          border-color: transparent black black black;

          > button {
            width: 100%;
            border-radius: 0;
            padding: 3px;
          }

          > .refresh-now {
            margin: 5px 0;
          }

          > .cancel-refresh {
            background-color: red;
            color: white;
          }
        }
      }

      > .last-refresh {
        margin: 0 5px;
      }
    }

    > .gantt-with-legends {
      height: calc(100% - 40px);
      display: flex;

      > .gantt-legends {
        min-width: 100px;
        max-width: 100px;
        height: fit-content;
        font-size: 10px;
        margin-left: 5px;

        > .gantt-legends-items {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          > .gantt-legends-color {
            max-width: 20px;
            min-width: 20px;
            max-height: 20px;
            min-height: 20px;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
.ems-trip-container {
  background-color: white;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  
  flex-direction: column;
  overflow: hidden;
  z-index: 98;
  width: 100%;
  display:list-item;

  > * {
    width: 100%;
    padding: 5px;
    display: flex;
  }

  >.vehicle-filter {
    background-color: white;
    height: 50%;
  }

  >.ems-footer{
    display: flex;
    align-items: center;
    >.button{
      width:100%;
    }

 }


}

.right-menu {
  z-index: 998;
  background-color: #eaeaea;
}


.rowBox{
  width:100%;
  display:flex;
  margin-top: 30px;
}


</style>